import clsx from 'clsx';

interface StatCardProps {
  title: string;
  value: React.ReactNode;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  subtext?: React.ReactNode;
  className?: string;
}

export function StatCard({
  title,
  value,
  icon: Icon,
  subtext,
  className,
}: StatCardProps) {
  return (
    <div className={clsx('card flex flex-col', className)}>
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-cyan-500/10 text-cyan-400">
          <Icon className="w-5 h-5" />
        </div>
        <h3 className="text-slate-400 text-sm font-medium">{title}</h3>
      </div>
      <div className="mt-auto">
        <div className="text-3xl font-bold text-white mb-1">{value}</div>
        {subtext && (
          <div className="text-sm text-slate-500 mt-1">{subtext}</div>
        )}
      </div>
    </div>
  );
}
